/**
 *
 * Records Page
 *
 */
import React, { useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  //  Label,
  // Table,
  //  FormGroup,
  //  Input,
  Button,
  // Spinner,
} from "reactstrap"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import Modal from "react-bootstrap/Modal"
import { withRouter, useParams } from "react-router-dom"
//  import ButtonSpinner from "../../components/ButtonSpinner"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as loginOtpAction from "../../store/bG9naW5fb3Rw/actions"
import { useSelector, useDispatch } from "react-redux"
//  import Select from "react-select"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

//Import Styles
import "./styles.scss"
import moment from "moment"
import { toast } from "react-toastify"

const LoginOtp = (props) => {
  const { dispatch } = props
  const specificDispatch = useDispatch()
  let { id } = useParams()
  const { SearchBar } = Search

  console.log(id)

  useEffect(() => {
    // dispatch(loginOtpAction.loadRecordsMetaData())
    dispatch(loginOtpAction.loadLoginOtp())
  }, [])

  const employeeUpdate = useSelector(
    (specificstate) => specificstate.employeeLoginOtp
  )
  const { login_otp = [] } = employeeUpdate

  console.log(employeeUpdate, "employee Update")
  console.log(login_otp, "employee Update")

  const editLoginOtpDetails = (employee) => {
    const updateLoginOtp = {
      employeeLoginOtpId: employee._id,
      approvedStatus: "Approved",
    }
    specificDispatch(loginOtpAction.updateLoginOtp(updateLoginOtp))
    setTimeout(() => {
      dispatch(loginOtpAction.loadLoginOtp())
      toast.success("Approved Successfully", {
        // position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
  }
  const removeLoginOtpDetails = (employee) => {
    const deleteLoginOtp = {
      employeeLoginOtpId: employee._id,
    }
    specificDispatch(loginOtpAction.deleteLoginOtp(deleteLoginOtp))
    setTimeout(() => {
      dispatch(loginOtpAction.loadLoginOtp())
      toast.success("Rejected Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
  }

  let slNo = 0
  const employeeDataTable = !isEmpty(login_otp)
    ? login_otp.map((employee, index) => {
        slNo = slNo + 1
        return {
          _id: employee._id,
          sNo: slNo,
          actions: (
            <div className="d-flex flex-row">
              <Button
                type="submit"
                style={{ fontSize: "10px" }}
                onClick={() => {
                  editLoginOtpDetails(employee)
                }}
                disabled={
                  employee.approvedStatus === "Approved" ||
                  employee.approvedStatus === "Completed"
                    ? true
                    : false
                }
                className="mx-1 btn btn-info"
              >
                <i className="fa fa-check icon-btn font-size-10"></i>
              </Button>
              <Button
                type="submit"
                style={{ fontSize: "10px" }}
                onClick={() => {
                  // setQuotationRemoveId(events.leadQuotationEventId)
                  // setDeleteForm(true)
                  removeLoginOtpDetails(employee)
                }}
                className="mx-1 btn btn-danger"
              >
                <i
                  className="bx bx-trash icon-btn font-size-10"
                ></i>
              </Button>
            </div>
          ),
          deviceId: employee.device,
          employeeId: employee.employeeId,
          otp: employee.otp,
          createdDate: moment(employee.createdAt).format("DD-MM-YYYY hh:mm A"),
          approvalStatus: employee.approvedStatus,
          approvedOn: moment(employee.approvedOn).format("DD-MM-YYYY hh:mm A"),
          employeeCode: employee.employeeCode,
          employeeName: employee.employeeName,
          empDetails: employee.empName.concat("-" + employee.empCode),
          subject: employee.subject,
          key: index,
        }
      })
    : []

  console.log(employeeDataTable, "employeeDataTable")

  // const [submittedResponse, setSubmittedResponse] = useState(true)

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "actions",
      text: "Actions",
      // sort: true,
      headerStyle: {
        minWidth: "105px",
      },
    },
    {
      dataField: "empDetails",
      text: "Employee",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "deviceId",
      text: "Device Id",
      sort: true,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "otp",
      text: "OTP",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    // {
    //   dataField: "approvedOn",
    //   text: "Approval Date",
    //   sort: true,
    //   headerStyle: {
    //     minWidth: "155px",
    //   },
    // },
    {
      dataField: "approvalStatus",
      text: "Approval Status",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
  ]

  const options = {
    sizePerPage: 10,
    totalSize: login_otp.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const title = "Login Otp"

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Master"} breadcrumbItem={title} />

          {/*Table start*/}
          <Col className="sales-approval-card mt-3">
            <Row className="sales-approval-form">
              <Col md="12" lg="12" xl="12" className="h-100 mt-3 mb-3">
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={employeeDataTable}
                      columns={columns}
                      search
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-column">
                              <Col className="mb-3">
                                <SearchBar {...props.searchProps} />
                              </Col>
                              <Col>
                                <BootstrapTable
                                  keyField={"_id"}
                                  // data={leaveDataTable}
                                  // columns={columns}
                                  {...props.baseProps}
                                  // pagination={paginationFactory()}
                                  responsive
                                  striped={true}
                                  bordered={true}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>

                <Modal>
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>REQUEST NO:</span>
                      <h1 className="request-header"></h1>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    <Col></Col>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" className="btn btn-danger">
                      Cancel
                    </Button>
                    <Button variant="primary" className="btn btn-success">
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Col>
            </Row>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  )
}

LoginOtp.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  login_otp: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
}

const mapStateToProps = (state) => ({
  login_otp: state.employeeLoginOtp.login_otp,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginOtp)
)
